import { render, staticRenderFns } from "./JobSearch.vue?vue&type=template&id=04fd903b&scoped=true&"
import script from "./JobSearch.vue?vue&type=script&lang=js&"
export * from "./JobSearch.vue?vue&type=script&lang=js&"
import style0 from "./JobSearch.vue?vue&type=style&index=0&id=04fd903b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd903b",
  null
  
)

export default component.exports